module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-alert', {
    attrs: {
      "title": "请点击下面按钮，在弹出的淘宝链接页面拍下您想要充值的金额，并通知我们的客服人员，我们会为您人工充值，所以在平台的余额会稍后进入您的账户",
      "type": "info"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "primary"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#fff",
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://item.taobao.com/item.htm?spm=a1z10.5-c.w4002-9892165116.67.MD9zv1&id=44420035512",
      "target": "_blank"
    }
  }, [_vm._v("充值")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-5f3e573a!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/store/recharge.vue
// module id = 222
// module chunks = 2